import { Button } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type AddButtonProps = {
  onClick: () => void;
};

const AddButton = ({ onClick }: AddButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={onClick}
      startIcon={<AddOutlined />}
      variant="text"
      data-testid={'ValueCondition.AddButton'}
      fullWidth={false}
    >
      {t(
        'forms.setPreparationTimeForm.fields.throttleSettings.addButton.label',
      )}
    </Button>
  );
};

export default AddButton;
